export default __webpack_public_path__ + "static/media/kiosk.a3b46004.png";